const de = {
    general: {
        app_name: "Aufgaben",
        overview: "Übersicht",
        archive: "Archiv",
        settings: "Einstellungen",
        dark_mode: "Dunkle Ansicht",
        close: "Schliessen"
    },
    overview: {
        header: "Deine Aufgaben",
        looksempty: "Hier sieht es leer aus. Zeit eine neue Aufgabe zu erstellen."
    },
    register: {
        email: "E-Mail",
        password: "Passwort",
        repeat_password: "Passwort wiederholen",
        register: "Registrieren",
        or_want_to_login: "oder einloggen?"
    },
    login: {
        login: "Login",
        email: "E-Mail",
        password: "Passwort",
        register_now: "Registrieren?",
        forgot_password: "Passwort vergessen?"
    },
    forgot_password: {
        header: "Passwort vergessen?",
        header_description: "Gebe unten deine E-Mail Adresse ein. Danach werden wir dir einen Link schicken, wo du dein Passwort zurücksetzen kannst.",
        email: "E-Mail",
        request_password: "Passwort anfordern",
        or_want_to_login: "Einloggen?"
    },
    reset_password: {
        notification: {
            new_password_has_been_set: "Das neue Passwort wurde gesetzt.",
            passwords_do_not_match: "Die Passwörter stimmen nicht überein."
        },
        header: "Passwort zurücksetzen",
        header_description: "Du kannst hier dein neues Passwort definieren, welches dann ab sofort aktiv ist.",
        new_password: "Neues Passwort",
        repeat_new_password: "Neues Passwort wiederholen",
        reset: "Zurücksetzen"
    },
    activate: {
        notification: {
            user_activated: "Der Benutzer wurde aktiviert."
        }
    },
    archive: {
        header: "Archiv"
    },
    detailtask: {
        notification: {
            marked_as_done: "Die Aufgabe wurde als erledigt markiert.",
            marked_as_done_on: "Die Aufgabe wurde am {date} um {time} erledigt.",
            task_deleted: "Die Aufgabe wurde gelöscht.",
            history_item_deleted: "Der Eintrag wurde gelöscht.",
            the_task_has_been_archived: "Die Aufgabe wurde archiviert."
        },
        back: "Zurück",
        edit: "Bearbeiten", 
        interval: "Interval",
        archive_task: "Aufgabe archivieren",
        unarchive_task: "Aufgabe wiederherstellen",
        next_execution: "Nächster Termin",
        history: "Vergangene Ausführungen",
        progress: "Fortschritt",
        delete_task: "Aufgabe löschen",
        load_more: "Mehr laden",
        now: "jetzt",
        on_specific_time: "andere Zeit",
        mark_as_done: "Als erledigt markieren",
        next: "weiter",
        set: "markieren",
        time_until_next_execution: "Zeit bis zur nächsten Ausführung",
        time_since_last_execution: "Zeit seit der letzten Ausführung",
        days: "Tag(e)",
        hours: "Stunde(n)",
        minutes: "Minute(n)",
        seconds: "Sekunde(n)",
        do_you_really_want_to_delete: "Möchtest du diese Aufgabe wirklich löschen?",
        no_history_available: "Bisher wurde die Aufgabe noch nie erledigt.",
        task_never_run: "Diese Aufgabe wurde noch nie erledigt. Erledige sie mindestens einmal und du siehst hier den Fortschritt.",
        do_you_want_to_delete_history_item: "Möchtest du wirklich diesen Eintrag löschen?"
    },
    addtask: {
        notification: {
            task_added: "Die Aufgabe wurde hinzugefügt."
        },
        header: "Aufgabe hinzufügen",
        name: "Name",
        description: "Beschreibung",
        interval: "Interval",
        add: "Hinzufügen",
        cancel: "Abbrechen"
    },
    edittask: {
        notification: {
            task_updated: "Die Aufgabe wurde gespeichert."
        },
        header: "Aufgabe bearbeiten",
        name: "Name",
        description: "Beschreibung",
        interval: "Interval",
        save: "Speichern",
        cancel: "Abbrechen"
    },
    taskcard: {
        next_execution: "Nächster Termin"
    },
    sessioncard: {
        delete: "Löschen",
        device_name: "Gerätename",
        device_os: "Betriebssystem",
        started: "Gestartet"
    },
    settings: {
        header: "Einstellungen",
        language: "Sprache",
        change_password: "Passwort ändern",
        current_password: "Aktuelles Passwort",
        new_password: "Neues Passwort",
        repeat_new_password: "Neues Passwort wiederholen",
        change: "ändern",
        profile: "Profil",
        sign_out: "Ausloggen",
        turn_on_notifications: "Benachrichtigungen einschalten",
        send_test_notification: "Testnachricht senden",
        test_notification_description: "Du kannst hier testen, ob die Nachrichten auf deinen Geräten ankommt.",
        devices: "Geräte",
        devices_description: "Hier findest du alle Geräte, welche mit deinem Konto verknüpft sind."
    },
    interval: {
        every_minute: "Jede Minute", 
        every_five_minutes: "5 Minuten",
        every_ten_minutes: "10 Minuten",
        every_fifteen_minutes: "15 Minuten",
        every_half_hour: "30 Minuten",
        every_hour: "Jede Stunde",
        every_second_hour: "Jede zweite Stunde",
        every_third_hour: "Jede dritte Stunde",
        every_fourth_hour: "Jede vierte Stunde",
        every_fifth_hour: "Jede fünfte Stunde",
        every_sixth_hour: "Jede sechste Stunde",
        every_day: "Jeden Tag",
        every_second_day: "Jeden zweiten Tag",
        every_third_day: "Jeden dritten Tag",
        every_fourth_day: "Jeden vierten Tag",
        every_fifth_day: "Jeden fünften Tag",
        every_sixth_day: "Jeden sechsten Tag",
        every_week: "Jede Woche",
        every_second_week: "Jede zweite Woche",
        every_third_week: "Jede dritte Woche",
        every_fourth_week: "Jede vierte Woche",
        every_fifth_week: "Jede fünfte Woche",
        every_month: "Jeden Monat",
        every_second_month: "Jeden zweiten Monat",
        every_third_month: "Jeden dritten Monat",
        every_fourth_month: "Jeden vierten Monat",
        every_fifth_month: "Jeden fünften Monat",
        every_half_year: "Jedes Halbjahr",
        every_year: "Jedes Jahr",
        every_second_year: "Jedes zweite Jahr"
    }
};

export default de;